import { render } from "./dol-card.vue?vue&type=template&id=5459fed5"
import script from "./dol-card.vue?vue&type=script&lang=js"
export * from "./dol-card.vue?vue&type=script&lang=js"

import "./dol-card.vue?vue&type=style&index=0&id=5459fed5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__